/**
 * Destino padrao seguro numa tela multitenant.
 *
 * Auditoria de 27/08/2026 em producao: com a sessao de staff (que enxerga TODOS
 * os clientes), toda tela que fazia `lista[0]` escolhia sozinha o PRIMEIRO
 * cliente da casa — um cliente pagante real — como destino de escrita. Em
 * /engineering isso foi reproduzido ao vivo: o seletor voltou sozinho para o
 * cliente real e a execucao saiu com ?client=<cliente real>.
 *
 * A regra passa a ser: so existe padrao quando NAO ha ambiguidade (uma unica
 * opcao). Com duas ou mais, quem escolhe e a pessoa — a tela nasce sem destino
 * e o formulario cobra a escolha. Perder um clique e barato; publicar no site
 * do cliente errado, nao.
 */
export function destinoPadrao<T extends { slug: string }>(
  opcoes: readonly T[] | undefined | null,
): string | undefined {
  if (!opcoes || opcoes.length !== 1) return undefined;
  return opcoes[0].slug;
}

/** True quando a escolha de destino e obrigatoria (ha mais de uma opcao). */
export function exigeEscolhaDeDestino<T>(opcoes: readonly T[] | undefined | null): boolean {
  return (opcoes?.length ?? 0) > 1;
}

const CHAVE_ULTIMO_DESTINO = 'wiredesk.ultimoDestino';

/** Ultimo destino escolhido neste navegador, se ainda for uma das opcoes. */
export function ultimoDestino<T extends { slug: string }>(
  opcoes: readonly T[] | undefined | null,
): string | undefined {
  try {
    const slug = window.localStorage.getItem(CHAVE_ULTIMO_DESTINO);
    return slug && opcoes?.some((o) => o.slug === slug) ? slug : undefined;
  } catch {
    return undefined;
  }
}

export function guardarUltimoDestino(slug: string): void {
  try {
    if (slug) window.localStorage.setItem(CHAVE_ULTIMO_DESTINO, slug);
  } catch {
    // navegador sem storage: so nao lembra
  }
}
